"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateOptions = void 0;
var getAllOptionsFns_1 = require("./getAllOptionsFns");
var generateOptions = function (_a) {
    var _b;
    var options = _a.options, optionsFn = _a.optionsFn, theme = _a.theme /*injectOtherOption*/;
    console.log('rerun generate options');
    switch (true) {
        case !!options:
            return options;
        // let otherOp = { display: "Other", value: "other" };
        // return injectOtherOption ? [...options, otherOp] : options;
        case !!optionsFn:
            return (_b = (0, getAllOptionsFns_1.getAllOptionsFns)(theme))[optionsFn.fn].apply(_b, (optionsFn.args || []));
        default:
            return [{ display: "Options Undefined", value: "undefined" }];
    }
};
exports.generateOptions = generateOptions;
